import { AppointmentProduct } from 'api/Serializers/AppointmentProducts';
import { Availability, WeeklyAvailability } from 'api/Serializers/Availability';
import { AvailabilityItem, CartStatus } from 'api/Serializers/Cart';
import { BookingType, DATE_FMT, QueryParams } from 'config';
import moment from 'moment-timezone';
import { APP_ROUTES } from 'utils/routing';
import { BookingData, BookingStep, StepState } from './types';

export const orderOfStepsSingle: BookingStep[] = [
  'datetime',
  'participants',
  'payment',
  'checkout',
  'confirmation',
];

export const orderOfStepsMulti: BookingStep[] = [
  'datetime',
  'series',
  'participants',
  'payment',
  'checkout',
  'confirmation',
];

export const getBookingStepState = (
  current: BookingStep,
  target: BookingStep,
  bookingType: BookingType
): StepState => {
  const orderOfSteps =
    bookingType === 'single' ? orderOfStepsSingle : orderOfStepsMulti;
  return current === target
    ? 'editing'
    : orderOfSteps.indexOf(target) < orderOfSteps.indexOf(current)
    ? 'complete'
    : 'hidden';
};

export const getStepLink = (
  step: BookingStep,
  type: BookingType,
  data: BookingData
) => {
  let params = new URLSearchParams(location.search);
  if (data?.selectedAvailability?.id !== undefined) {
    params.set(QueryParams.Availability, data.selectedAvailability.id);
  }
  return `${APP_ROUTES.BOOK.nav(
    data?.appointmentProduct.id,
    type,
    step
  )}?${params.toString()}`;
};

export const getCanEditCart = (status: CartStatus) => {
  return ['EMPTY', 'STARTED', 'ERROR'].includes(status);
};

export const toLocalTime = (dt: string, timezone: string) =>
  moment(dt).tz(timezone);

export const getDatetimeStr = (
  appointmentProduct: AppointmentProduct,
  availability: WeeklyAvailability | Availability | AvailabilityItem
) =>
  toLocalTime(availability.start, appointmentProduct.timezone)
    .format(DATE_FMT.DOW_SHORT_MON_D_TIME_A)
    .replace(':00', '') +
  '-' +
  toLocalTime(availability.end, appointmentProduct.timezone)
    ?.format(DATE_FMT.TIME_A)
    .replace(':00', '');
